import { useMemo } from "react";
import useCurrentUser, { deriveGivenName, type CurrentUser } from "./useCurrentUser";
import { useAssumeUser } from "@/providers/AssumeUserProvider";

export type EffectiveDisplayUser = Pick<
  CurrentUser,
  "sub" | "email" | "name" | "given_name" | "family_name" | "picture" | "department" | "location" | "organization"
>;

function deriveFamilyName(fullName: string): string {
  return fullName.trim().split(/\s+/).slice(1).join(" ");
}

export default function useEffectiveDisplayUser(): EffectiveDisplayUser {
  const { user } = useCurrentUser();
  const { assumedUser } = useAssumeUser();

  return useMemo(() => {
    if (!assumedUser) return user;

    return {
      sub: assumedUser.id,
      email: assumedUser.email,
      name: assumedUser.name,
      given_name: deriveGivenName(undefined, assumedUser.name),
      family_name: deriveFamilyName(assumedUser.name),
      picture: assumedUser.photo ?? "",
      department: assumedUser.department ?? "",
      location: "",
      organization: ""
    };
  }, [assumedUser, user]);
}
